import React from 'react';
import { CheckIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from './ui/Button';
import { company, credibilityItems, heroImage } from '../data/site';
export function Hero() {
  return <section id="home" aria-labelledby="hero-heading" className="relative" data-id="element-181" data-mp="9lv0spiridvb">
      <div className="relative isolate overflow-hidden bg-charcoal-900" data-id="element-182" data-mp="4lyswf6y22ah">
        <img src={heroImage} alt="CoPro Services painting crew applying fresh coating to the interior wall of a Central Florida warehouse" className="absolute inset-0 h-full w-full object-cover" loading="eager" data-id="element-183" data-mp="4jvup7vn12uo" />
        <div className="absolute inset-0 bg-charcoal-900/78" aria-hidden="true" data-id="element-184" data-mp="s9zxxe4wz0l5" />
        <div className="absolute inset-y-0 left-0 w-full max-w-3xl bg-charcoal-900/45" aria-hidden="true" data-id="element-185" data-mp="nbomx02vuk1c" />

        <div className="relative mx-auto max-w-container px-5 pb-24 pt-36 sm:pb-28 sm:pt-44 lg:px-8 lg:pb-36 lg:pt-52" data-id="element-186" data-mp="382fgbrjt9agi">
          <div className="max-w-3xl" data-id="element-187" data-mp="3j7zhlpe3m4ju">
            <p className="flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.16em] text-cobalt-200" data-id="element-188" data-mp="3j9247l4e1kty">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-189" data-mp="3o5j2h85axfkr" />
              {company.serviceArea}
            </p>

            <h1 id="hero-heading" className="mt-6 text-[2.6rem] font-extrabold leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-[4.25rem]" data-id="element-190" data-mp="3e9fqzbok84l5">
              Professional Solutions.
              <br data-id="element-191" data-mp="358zu4l2bnvp9" />
              <span className="text-cobalt-300" data-id="element-192" data-mp="35aau09sncjb3">Reliable Results.</span>
            </h1>

            <p className="mt-7 max-w-2xl text-lg leading-relaxed text-charcoal-100 sm:text-xl" data-id="element-193" data-mp="2ql6b0qe12b1x">
              Commercial painting, industrial cleaning and property services
              delivered with professionalism, attention to detail and
              personalized service.
            </p>

            <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-194" data-mp="2ljpbozb6ywng">
              <ButtonLink href="#contact" size="lg" data-id="element-195" data-mp="s3351dk4moxj">
                Request a Free Quote
              </ButtonLink>
              <ButtonLink href={company.phoneHref} variant="outlineLight" size="lg" data-id="element-196" data-mp="n9qhz7v3iq6w">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-197" data-mp="ddf3qcby3q9t" />
                Call {company.phoneDisplay}
              </ButtonLink>
            </div>
          </div>
        </div>
      </div>

      <div className="border-b border-charcoal-100 bg-white" data-id="element-198" data-mp="161t0korasgjs">
        <ul className="mx-auto grid max-w-container grid-cols-1 gap-x-8 divide-y divide-charcoal-100 px-5 sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-4 lg:px-8" data-id="element-199" data-mp="162m137zny9th">
          {credibilityItems.map(item => <li key={item} className="flex items-center gap-3 py-4 lg:justify-center lg:py-5" data-id="element-200" data-mp="x0utfxlkbswz">
              <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cobalt-50 text-cobalt-700" aria-hidden="true" data-id="element-201" data-mp="3hrllakmueba1">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-202" data-mp="21amuh5blvkk8" />
              </span>
              <span className="text-sm font-bold tracking-tight text-charcoal-800" data-id="element-203" data-mp="269zj9vm1f1pg">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}